export enum NotificationTypes {
  TICKETS_NEW = 'tickets_new',
  TICKETS_TRANSFER_MYSELF = 'tickets_transfer_myself',
  TICKETS_TRANSFER_DEPARTMENT = 'tickets_transfer_department',
  TICKETS_ASSIGN = 'tickets_assign',
  LEAVE_ORDER_NEW = 'leave_order_new',
}
